import { CELL_SIZE } from "../constants";

export class SpatialGrid {
  constructor() { this.cells = new Map(); }

  _k(cx, cy)  { return `${cx},${cy}`; }
  _c(mm)      { return Math.floor(mm / CELL_SIZE); }

  _cells(x0, y0, x1, y1) {
    const o = [];
    for (let cx = this._c(Math.min(x0, x1)); cx <= this._c(Math.max(x0, x1)); cx++)
      for (let cy = this._c(Math.min(y0, y1)); cy <= this._c(Math.max(y0, y1)); cy++)
        o.push([cx, cy]);
    return o;
  }

  insert(id, x0, y0, x1, y1) {
    for (const [cx, cy] of this._cells(x0, y0, x1, y1)) {
      const k = this._k(cx, cy);
      if (!this.cells.has(k)) this.cells.set(k, new Set());
      this.cells.get(k).add(id);
    }
  }

  query(x0, y0, x1, y1) {
    const r = new Set();
    for (const [cx, cy] of this._cells(x0, y0, x1, y1)) {
      const c = this.cells.get(this._k(cx, cy));
      if (c) for (const id of c) r.add(id);
    }
    return r;
  }
}

export function buildGrid(st) {
  const g = new SpatialGrid();
  for (const e of Object.values(st.edges)) {
    const ab = st.halfEdges[e.halfEdgeA], ba = st.halfEdges[e.halfEdgeB];
    if (!ab || !ba) continue;
    const nA = st.nodes[ab.originId], nB = st.nodes[ba.originId];
    if (!nA || !nB) continue;
    g.insert(e.id, nA.x, nA.y, nB.x, nB.y);
  }
  return g;
}
